export class NotificationEvent{
    id:any=null;
    accountId:any=null;
    label:any=null;
    code:any=null;
    sms:boolean = false;
    email:boolean = false;
    whatsapp:boolean = false;
    smsEnabled:boolean = false;
    emailEnabled:boolean = false;
    notificationMode:any = null; 
    whatsappEnabled:boolean = false;
}